import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  FeatureCard,
  Gallery,
  SpacerV,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";
import { Fragment } from "react";

export default function Software() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Hero
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          title="Mobile Apps"
          subtitle={
            <div>
              <p>
                Our mobile app development expertise ensures seamless user
                experiences, high performance, and scalable solutions. Here’s
                why we’re the right choice for your business:
              </p>
              {!state.auth.isMobile ? (
                <ul>
                  <li>
                    <strong>Custom-Built Solutions</strong>: We develop
                    tailor-made apps for iOS and Android, ensuring they align
                    with your business goals and user needs.
                  </li>
                  <li>
                    <strong>Performance & Scalability</strong>: Our apps are
                    optimized for speed, responsiveness, and scalability,
                    ensuring a seamless experience as your user base grows.
                  </li>
                  <li>
                    <strong>Cutting-Edge Technologies</strong>: We leverage the
                    latest frameworks, including Flutter and React Native, to
                    build efficient and feature-rich applications.
                  </li>
                </ul>
              ) : (
                ""
              )}
              <p>
                By hiring us, you gain a partner dedicated to delivering
                user-friendly, high-quality, and innovative mobile applications
                that drive business success.
              </p>
            </div>
          }
        />

        <ContentSideBySideInv
          title="Key benefits of Mobile app Solutions for Business"
          subtitle={
            <div style={{ marginLeft: "15px" }}>
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
               Enhanced Customer Engagement
              </div>
              Mobile apps provide a direct and personalized communication channel with customers, fostering stronger relationships and higher engagement levels.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Improved Accessibility{" "}
              </div>
               Mobile apps offer convenience and accessibility, allowing customers to interact with your 
               business anytime and anywhere, leading to increased customer satisfaction.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                Increased Sales and Revenue
              </div>
              With features like in-app purchases, push notifications, and personalized offers, 
              mobile apps can drive sales and boost revenue.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/marketing (8).json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <SpacerV height={"100px"} />
        <SpacerV height={"100px"} />
        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={" Android Mobile App Development"}
                text={` We focus on crafting customized applications for the Android
                platform. Our team utilizes Java and Kotlin to create apps that
                leverage Android’s extensive user base and versatile features in
                your app.`}
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Native App Development"}
                text={`We create Progressive Web Apps that blend the best of web and
                mobile app features. Our PWAs are developed using HTML, CSS, and
                JavaScript. They bring users engaging experiences across devices
                and offline capabilities to your app.`}
                icon={
                  <BlurOnIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={" IOS Mobile App Development"}
                text={`Our team excels in designing intuitive and sleek apps for Apple
                devices. By employing Swift and Objective-C, we focus on
                maximizing performance. Our ultimate aim is to enhance user
                satisfaction on iOS platforms.`}
                icon={
                  <DvrIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"PWA Development"}
                text={`We develop platform-specific applications to ensure optimal
              performance and seamless integration. Our expertise includes
              using Java and Kotlin for Android, and Swift and Objective-C for
              iOS which guarantee superior user experiences.`}
                icon={
                  <TabIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Cross Platform App Development"}
                text={` Our expertise extends to building cross-platform apps that run
                flawlessly on both Android and iOS. We utilize frameworks like
                Flutter and React Native for effective code utilization and
                experiences.`}
                icon={
                  <WindowIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"End to End Development"}
                text={`We offer comprehensive app development services and guide
              projects from concept to completion. This includes creativity,
              design, coding, testing, deployment, and maintenance, which
              guarantees a successful app launch.`}
                icon={
                  <DoubleArrowIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />
        <Stats />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
